import { ContentEditor as ContentEditorComponent } from './ContentEditor.component';
import { connector } from './ContentEditor.connector';
export const ContentEditor = connector(ContentEditorComponent);
